import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import FileItem from '../FileItem';
import ImageItem from '../ImageItem';

import styles from './files-list.module.scss';

const FilesList = ({
  files,
  actions = {},
  handleSelectionChange,
  handleSelectionTypeChange,
  initOptsMove = [],
  selectedFiles: controlledSelectedFiles,
}, ref) => {
  const [internalSelectedFiles, setInternalSelectedFiles] = useState([]);
  const [selectedFilesWithTypes, setSelectedFilesWithTypes] = useState([]);

  const isControlled = controlledSelectedFiles != null;
  const selectedFiles = isControlled ? controlledSelectedFiles : internalSelectedFiles;

  useImperativeHandle(ref, () => ({
    resetSelection: () => {
      setInternalSelectedFiles([]);
      setSelectedFilesWithTypes([]);
    },
  }), []);

  const handleSelectFile = (fileId, type) => {
    const newSelectedFiles = selectedFiles.includes(fileId)
      ? selectedFiles.filter((id) => id !== fileId)
      : [...selectedFiles, fileId];

    const newSelectedFilesWithTypes = selectedFilesWithTypes.find((f) => f.id === fileId)
      ? selectedFilesWithTypes.filter((f) => f.id !== fileId)
      : [...selectedFilesWithTypes, { id: fileId, type }];

    if (!isControlled) {
      setInternalSelectedFiles(newSelectedFiles);
      setSelectedFilesWithTypes(newSelectedFilesWithTypes);
    }

    if (handleSelectionChange) handleSelectionChange(newSelectedFiles);
    if (!isControlled && handleSelectionTypeChange) {
      const allImages = newSelectedFilesWithTypes.length > 0
        && newSelectedFilesWithTypes.every((f) => f.type === 'image');
      handleSelectionTypeChange(allImages);
    }
  };

  useEffect(() => {
    if (!isControlled && handleSelectionChange) handleSelectionChange(internalSelectedFiles);
  }, [internalSelectedFiles, isControlled]);

  const isImage = (file) => file.mimetype.startsWith('image/');

  const actionsWithoutSend = Object.fromEntries(
    Object.entries(actions).filter(([key]) => key !== 'send'),
  );

  return (
    <div className={styles.foldersList}>
      {files && (
        <>
          <ul className={styles.imageContainer}>
            {files.filter((file) => isImage(file)).map((file) => (
              <ImageItem
                handleSelect={handleSelectFile}
                actions={actions}
                initOptsMove={initOptsMove}
                key={`file-${file._id}`}
                file={file}
                selected={selectedFiles.includes(file._id)}
              />
            ))}
            </ul>
            <ul>
            {files.filter((file) => !isImage(file)).map((file) => (
              <FileItem
                handleSelect={handleSelectFile}
                actions={actionsWithoutSend}
                initOptsMove={initOptsMove}
                key={`file-${file._id}`}
                file={file}
                selected={selectedFiles.includes(file._id)}
              />
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default forwardRef(FilesList);
